import { getCookie } from '@app/javascript/classes/cookies'

export const storageKey = (name) => `collapse-${getCookie('user_id')}-${window.location.pathname}-${name}`

export const getCollapsedState = (name) => JSON.parse(localStorage.getItem(storageKey(name)))

export const setCollapsedState = (name, value) => localStorage.setItem(storageKey(name), value)
